import { useEffect, useState } from "react";
import { Outlet, useParams } from "react-router-dom";
import { useAuth } from "../lib/useAuth";
import { apiGet } from "../lib/api";
import type { Company } from "../types";

export function PortalLayout() {
  const { companyId } = useParams();
  const { logout } = useAuth();
  const [company, setCompany] = useState<Company | null>(null);

  useEffect(() => {
    if (!companyId) return;
    apiGet<Company>(`/api/portal/company?companyId=${encodeURIComponent(companyId)}`)
      .then(setCompany)
      .catch(() => void 0);
  }, [companyId]);

  return (
    <>
      <header className="app">
        <div className="logo">💊</div>
        <div style={{ flex: 1 }}>
          <h1>{company?.name || "情報ポータル"}</h1>
          <div className="sub">薬局 情報伝達ハブ / c/{companyId}</div>
        </div>
        <button className="btn ghost sm no-print" onClick={() => logout()}>
          ログアウト
        </button>
      </header>
      <main>
        <Outlet />
      </main>
    </>
  );
}
